// Generated by tools/currencies/update-iso4217.py. Do not edit by hand.
// Source: https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xml and list-three.xml
// Published: {"list-one.xml": "2026-09-17", "list-three.xml": "2026-01-01"}
export const CURRENCIES = ["ILS", "USD", "EUR", "ADP", "AED", "AFA", "AFN", "ALK", "ALL", "AMD", "ANG", "AOA", "AOK", "AON", "AOR", "ARA", "ARP", "ARS", "ARY", "ATS", "AUD", "AWG", "AYM", "AZM", "AZN", "BAD", "BAM", "BBD", "BDT", "BEC", "BEF", "BEL", "BGJ", "BGK", "BGL", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOP", "BOV", "BRB", "BRC", "BRE", "BRL", "BRN", "BRR", "BSD", "BTN", "BUK", "BWP", "BYB", "BYN", "BYR", "BZD", "CAD", "CDF", "CHC", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CSD", "CSJ", "CSK", "CUC", "CUP", "CVE", "CYP", "CZK", "DDM", "DEM", "DJF", "DKK", "DOP", "DZD", "ECS", "ECV", "EEK", "EGP", "ERN", "ESA", "ESB", "ESP", "ETB", "FIM", "FJD", "FKP", "FRF", "GBP", "GEK", "GEL", "GHC", "GHP", "GHS", "GIP", "GMD", "GNE", "GNF", "GNS", "GQE", "GRD", "GTQ", "GWE", "GWP", "GYD", "HKD", "HNL", "HRD", "HRK", "HTG", "HUF", "IDR", "IEP", "ILP", "ILR", "INR", "IQD", "IRR", "ISJ", "ISK", "ITL", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAJ", "LAK", "LBP", "LKR", "LRD", "LSL", "LSM", "LTL", "LTT", "LUC", "LUF", "LUL", "LVL", "LVR", "LYD", "MAD", "MDL", "MGA", "MGF", "MKD", "MLF", "MMK", "MNT", "MOP", "MRO", "MRU", "MTL", "MTP", "MUR", "MVQ", "MVR", "MWK", "MXN", "MXP", "MXV", "MYR", "MZE", "MZM", "MZN", "NAD", "NGN", "NIC", "NIO", "NLG", "NOK", "NPR", "NZD", "OMR", "PAB", "PEH", "PEI", "PEN", "PES", "PGK", "PHP", "PKR", "PLN", "PLZ", "PTE", "PYG", "QAR", "RHD", "ROK", "ROL", "RON", "RSD", "RUB", "RUR", "RWF", "SAR", "SBD", "SCR", "SDD", "SDG", "SDP", "SEK", "SGD", "SHP", "SIT", "SKK", "SLE", "SLL", "SOS", "SRD", "SRG", "SSP", "STD", "STN", "SUR", "SVC", "SYP", "SZL", "THB", "TJR", "TJS", "TMM", "TMT", "TND", "TOP", "TPE", "TRL", "TRY", "TTD", "TWD", "TZS", "UAH", "UAK", "UGS", "UGW", "UGX", "USN", "USS", "UYI", "UYN", "UYP", "UYU", "UYW", "UZS", "VEB", "VED", "VEF", "VES", "VNC", "VND", "VUV", "WST", "XAD", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XCG", "XDR", "XEU", "XFO", "XFU", "XOF", "XPD", "XPF", "XPT", "XRE", "XSU", "XUA", "YDD", "YER", "YUD", "YUM", "YUN", "ZAL", "ZAR", "ZMK", "ZMW", "ZRN", "ZRZ", "ZWC", "ZWD", "ZWG", "ZWL", "ZWN", "ZWR"] as const;

export const ISO_CURRENCIES = {
  "ILS": {
    "name": "New Israeli Sheqel",
    "digits": 2,
    "active": true
  },
  "USD": {
    "name": "US Dollar",
    "digits": 2,
    "active": true
  },
  "EUR": {
    "name": "Euro",
    "digits": 2,
    "active": true
  },
  "ADP": {
    "name": "Andorran Peseta",
    "digits": null,
    "active": false
  },
  "AED": {
    "name": "UAE Dirham",
    "digits": 2,
    "active": true
  },
  "AFA": {
    "name": "Afghani",
    "digits": null,
    "active": false
  },
  "AFN": {
    "name": "Afghani",
    "digits": 2,
    "active": true
  },
  "ALK": {
    "name": "Old Lek",
    "digits": null,
    "active": false
  },
  "ALL": {
    "name": "Lek",
    "digits": 2,
    "active": true
  },
  "AMD": {
    "name": "Armenian Dram",
    "digits": 2,
    "active": true
  },
  "ANG": {
    "name": "Netherlands Antillean Guilder",
    "digits": null,
    "active": false
  },
  "AOA": {
    "name": "Kwanza",
    "digits": 2,
    "active": true
  },
  "AOK": {
    "name": "Kwanza",
    "digits": null,
    "active": false
  },
  "AON": {
    "name": "New Kwanza",
    "digits": null,
    "active": false
  },
  "AOR": {
    "name": "Kwanza Reajustado",
    "digits": null,
    "active": false
  },
  "ARA": {
    "name": "Austral",
    "digits": null,
    "active": false
  },
  "ARP": {
    "name": "Peso Argentino",
    "digits": null,
    "active": false
  },
  "ARS": {
    "name": "Argentine Peso",
    "digits": 2,
    "active": true
  },
  "ARY": {
    "name": "Peso",
    "digits": null,
    "active": false
  },
  "ATS": {
    "name": "Schilling",
    "digits": null,
    "active": false
  },
  "AUD": {
    "name": "Australian Dollar",
    "digits": 2,
    "active": true
  },
  "AWG": {
    "name": "Aruban Florin",
    "digits": 2,
    "active": true
  },
  "AYM": {
    "name": "Azerbaijan Manat",
    "digits": null,
    "active": false
  },
  "AZM": {
    "name": "Azerbaijanian Manat",
    "digits": null,
    "active": false
  },
  "AZN": {
    "name": "Azerbaijan Manat",
    "digits": 2,
    "active": true
  },
  "BAD": {
    "name": "Dinar",
    "digits": null,
    "active": false
  },
  "BAM": {
    "name": "Convertible Mark",
    "digits": 2,
    "active": true
  },
  "BBD": {
    "name": "Barbados Dollar",
    "digits": 2,
    "active": true
  },
  "BDT": {
    "name": "Taka",
    "digits": 2,
    "active": true
  },
  "BEC": {
    "name": "Convertible Franc",
    "digits": null,
    "active": false
  },
  "BEF": {
    "name": "Belgian Franc",
    "digits": null,
    "active": false
  },
  "BEL": {
    "name": "Financial Franc",
    "digits": null,
    "active": false
  },
  "BGJ": {
    "name": "Lev A/52",
    "digits": null,
    "active": false
  },
  "BGK": {
    "name": "Lev A/62",
    "digits": null,
    "active": false
  },
  "BGL": {
    "name": "Lev",
    "digits": null,
    "active": false
  },
  "BGN": {
    "name": "Bulgarian Lev",
    "digits": null,
    "active": false
  },
  "BHD": {
    "name": "Bahraini Dinar",
    "digits": 3,
    "active": true
  },
  "BIF": {
    "name": "Burundi Franc",
    "digits": 0,
    "active": true
  },
  "BMD": {
    "name": "Bermudian Dollar",
    "digits": 2,
    "active": true
  },
  "BND": {
    "name": "Brunei Dollar",
    "digits": 2,
    "active": true
  },
  "BOB": {
    "name": "Boliviano",
    "digits": 2,
    "active": true
  },
  "BOP": {
    "name": "Peso boliviano",
    "digits": null,
    "active": false
  },
  "BOV": {
    "name": "Mvdol",
    "digits": 2,
    "active": true
  },
  "BRB": {
    "name": "Cruzeiro",
    "digits": null,
    "active": false
  },
  "BRC": {
    "name": "Cruzado",
    "digits": null,
    "active": false
  },
  "BRE": {
    "name": "Cruzeiro",
    "digits": null,
    "active": false
  },
  "BRL": {
    "name": "Brazilian Real",
    "digits": 2,
    "active": true
  },
  "BRN": {
    "name": "New Cruzado",
    "digits": null,
    "active": false
  },
  "BRR": {
    "name": "Cruzeiro Real",
    "digits": null,
    "active": false
  },
  "BSD": {
    "name": "Bahamian Dollar",
    "digits": 2,
    "active": true
  },
  "BTN": {
    "name": "Ngultrum",
    "digits": 2,
    "active": true
  },
  "BUK": {
    "name": "Kyat",
    "digits": null,
    "active": false
  },
  "BWP": {
    "name": "Pula",
    "digits": 2,
    "active": true
  },
  "BYB": {
    "name": "Belarusian Ruble",
    "digits": null,
    "active": false
  },
  "BYN": {
    "name": "Belarusian Ruble",
    "digits": 2,
    "active": true
  },
  "BYR": {
    "name": "Belarusian Ruble",
    "digits": null,
    "active": false
  },
  "BZD": {
    "name": "Belize Dollar",
    "digits": 2,
    "active": true
  },
  "CAD": {
    "name": "Canadian Dollar",
    "digits": 2,
    "active": true
  },
  "CDF": {
    "name": "Congolese Franc",
    "digits": 2,
    "active": true
  },
  "CHC": {
    "name": "WIR Franc (for electronic)",
    "digits": null,
    "active": false
  },
  "CHE": {
    "name": "WIR Euro",
    "digits": 2,
    "active": true
  },
  "CHF": {
    "name": "Swiss Franc",
    "digits": 2,
    "active": true
  },
  "CHW": {
    "name": "WIR Franc",
    "digits": 2,
    "active": true
  },
  "CLF": {
    "name": "Unidad de Fomento",
    "digits": 4,
    "active": true
  },
  "CLP": {
    "name": "Chilean Peso",
    "digits": 0,
    "active": true
  },
  "CNY": {
    "name": "Yuan Renminbi",
    "digits": 2,
    "active": true
  },
  "COP": {
    "name": "Colombian Peso",
    "digits": 2,
    "active": true
  },
  "COU": {
    "name": "Unidad de Valor Real",
    "digits": 2,
    "active": true
  },
  "CRC": {
    "name": "Costa Rican Colon",
    "digits": 2,
    "active": true
  },
  "CSD": {
    "name": "Serbian Dinar",
    "digits": null,
    "active": false
  },
  "CSJ": {
    "name": "Krona A/53",
    "digits": null,
    "active": false
  },
  "CSK": {
    "name": "Koruna",
    "digits": null,
    "active": false
  },
  "CUC": {
    "name": "Peso Convertible",
    "digits": null,
    "active": false
  },
  "CUP": {
    "name": "Cuban Peso",
    "digits": 2,
    "active": true
  },
  "CVE": {
    "name": "Cabo Verde Escudo",
    "digits": 2,
    "active": true
  },
  "CYP": {
    "name": "Cyprus Pound",
    "digits": null,
    "active": false
  },
  "CZK": {
    "name": "Czech Koruna",
    "digits": 2,
    "active": true
  },
  "DDM": {
    "name": "Mark der DDR",
    "digits": null,
    "active": false
  },
  "DEM": {
    "name": "Deutsche Mark",
    "digits": null,
    "active": false
  },
  "DJF": {
    "name": "Djibouti Franc",
    "digits": 0,
    "active": true
  },
  "DKK": {
    "name": "Danish Krone",
    "digits": 2,
    "active": true
  },
  "DOP": {
    "name": "Dominican Peso",
    "digits": 2,
    "active": true
  },
  "DZD": {
    "name": "Algerian Dinar",
    "digits": 2,
    "active": true
  },
  "ECS": {
    "name": "Sucre",
    "digits": null,
    "active": false
  },
  "ECV": {
    "name": "Unidad de Valor Constante (UVC)",
    "digits": null,
    "active": false
  },
  "EEK": {
    "name": "Kroon",
    "digits": null,
    "active": false
  },
  "EGP": {
    "name": "Egyptian Pound",
    "digits": 2,
    "active": true
  },
  "ERN": {
    "name": "Nakfa",
    "digits": 2,
    "active": true
  },
  "ESA": {
    "name": "Spanish Peseta",
    "digits": null,
    "active": false
  },
  "ESB": {
    "name": "\"A\" Account (convertible Peseta Account)",
    "digits": null,
    "active": false
  },
  "ESP": {
    "name": "Spanish Peseta",
    "digits": null,
    "active": false
  },
  "ETB": {
    "name": "Ethiopian Birr",
    "digits": 2,
    "active": true
  },
  "FIM": {
    "name": "Markka",
    "digits": null,
    "active": false
  },
  "FJD": {
    "name": "Fiji Dollar",
    "digits": 2,
    "active": true
  },
  "FKP": {
    "name": "Falkland Islands Pound",
    "digits": 2,
    "active": true
  },
  "FRF": {
    "name": "French Franc",
    "digits": null,
    "active": false
  },
  "GBP": {
    "name": "Pound Sterling",
    "digits": 2,
    "active": true
  },
  "GEK": {
    "name": "Georgian Coupon",
    "digits": null,
    "active": false
  },
  "GEL": {
    "name": "Lari",
    "digits": 2,
    "active": true
  },
  "GHC": {
    "name": "Cedi",
    "digits": null,
    "active": false
  },
  "GHP": {
    "name": "Ghana Cedi",
    "digits": null,
    "active": false
  },
  "GHS": {
    "name": "Ghana Cedi",
    "digits": 2,
    "active": true
  },
  "GIP": {
    "name": "Gibraltar Pound",
    "digits": 2,
    "active": true
  },
  "GMD": {
    "name": "Dalasi",
    "digits": 2,
    "active": true
  },
  "GNE": {
    "name": "Syli",
    "digits": null,
    "active": false
  },
  "GNF": {
    "name": "Guinean Franc",
    "digits": 0,
    "active": true
  },
  "GNS": {
    "name": "Syli",
    "digits": null,
    "active": false
  },
  "GQE": {
    "name": "Ekwele",
    "digits": null,
    "active": false
  },
  "GRD": {
    "name": "Drachma",
    "digits": null,
    "active": false
  },
  "GTQ": {
    "name": "Quetzal",
    "digits": 2,
    "active": true
  },
  "GWE": {
    "name": "Guinea Escudo",
    "digits": null,
    "active": false
  },
  "GWP": {
    "name": "Guinea-Bissau Peso",
    "digits": null,
    "active": false
  },
  "GYD": {
    "name": "Guyana Dollar",
    "digits": 2,
    "active": true
  },
  "HKD": {
    "name": "Hong Kong Dollar",
    "digits": 2,
    "active": true
  },
  "HNL": {
    "name": "Lempira",
    "digits": 2,
    "active": true
  },
  "HRD": {
    "name": "Croatian Dinar",
    "digits": null,
    "active": false
  },
  "HRK": {
    "name": "Kuna",
    "digits": null,
    "active": false
  },
  "HTG": {
    "name": "Gourde",
    "digits": 2,
    "active": true
  },
  "HUF": {
    "name": "Forint",
    "digits": 2,
    "active": true
  },
  "IDR": {
    "name": "Rupiah",
    "digits": 2,
    "active": true
  },
  "IEP": {
    "name": "Irish Pound",
    "digits": null,
    "active": false
  },
  "ILP": {
    "name": "Pound",
    "digits": null,
    "active": false
  },
  "ILR": {
    "name": "Old Shekel",
    "digits": null,
    "active": false
  },
  "INR": {
    "name": "Indian Rupee",
    "digits": 2,
    "active": true
  },
  "IQD": {
    "name": "Iraqi Dinar",
    "digits": 3,
    "active": true
  },
  "IRR": {
    "name": "Iranian Rial",
    "digits": 2,
    "active": true
  },
  "ISJ": {
    "name": "Old Krona",
    "digits": null,
    "active": false
  },
  "ISK": {
    "name": "Iceland Krona",
    "digits": 0,
    "active": true
  },
  "ITL": {
    "name": "Italian Lira",
    "digits": null,
    "active": false
  },
  "JMD": {
    "name": "Jamaican Dollar",
    "digits": 2,
    "active": true
  },
  "JOD": {
    "name": "Jordanian Dinar",
    "digits": 3,
    "active": true
  },
  "JPY": {
    "name": "Yen",
    "digits": 0,
    "active": true
  },
  "KES": {
    "name": "Kenyan Shilling",
    "digits": 2,
    "active": true
  },
  "KGS": {
    "name": "Som",
    "digits": 2,
    "active": true
  },
  "KHR": {
    "name": "Riel",
    "digits": 2,
    "active": true
  },
  "KMF": {
    "name": "Comorian Franc ",
    "digits": 0,
    "active": true
  },
  "KPW": {
    "name": "North Korean Won",
    "digits": 2,
    "active": true
  },
  "KRW": {
    "name": "Won",
    "digits": 0,
    "active": true
  },
  "KWD": {
    "name": "Kuwaiti Dinar",
    "digits": 3,
    "active": true
  },
  "KYD": {
    "name": "Cayman Islands Dollar",
    "digits": 2,
    "active": true
  },
  "KZT": {
    "name": "Tenge",
    "digits": 2,
    "active": true
  },
  "LAJ": {
    "name": "Pathet Lao Kip",
    "digits": null,
    "active": false
  },
  "LAK": {
    "name": "Lao Kip",
    "digits": 2,
    "active": true
  },
  "LBP": {
    "name": "Lebanese Pound",
    "digits": 2,
    "active": true
  },
  "LKR": {
    "name": "Sri Lanka Rupee",
    "digits": 2,
    "active": true
  },
  "LRD": {
    "name": "Liberian Dollar",
    "digits": 2,
    "active": true
  },
  "LSL": {
    "name": "Loti",
    "digits": 2,
    "active": true
  },
  "LSM": {
    "name": "Loti",
    "digits": null,
    "active": false
  },
  "LTL": {
    "name": "Lithuanian Litas",
    "digits": null,
    "active": false
  },
  "LTT": {
    "name": "Talonas",
    "digits": null,
    "active": false
  },
  "LUC": {
    "name": "Luxembourg Convertible Franc",
    "digits": null,
    "active": false
  },
  "LUF": {
    "name": "Luxembourg Franc",
    "digits": null,
    "active": false
  },
  "LUL": {
    "name": "Luxembourg Financial Franc",
    "digits": null,
    "active": false
  },
  "LVL": {
    "name": "Latvian Lats",
    "digits": null,
    "active": false
  },
  "LVR": {
    "name": "Latvian Ruble",
    "digits": null,
    "active": false
  },
  "LYD": {
    "name": "Libyan Dinar",
    "digits": 3,
    "active": true
  },
  "MAD": {
    "name": "Moroccan Dirham",
    "digits": 2,
    "active": true
  },
  "MDL": {
    "name": "Moldovan Leu",
    "digits": 2,
    "active": true
  },
  "MGA": {
    "name": "Malagasy Ariary",
    "digits": 2,
    "active": true
  },
  "MGF": {
    "name": "Malagasy Franc",
    "digits": null,
    "active": false
  },
  "MKD": {
    "name": "Denar",
    "digits": 2,
    "active": true
  },
  "MLF": {
    "name": "Mali Franc",
    "digits": null,
    "active": false
  },
  "MMK": {
    "name": "Kyat",
    "digits": 2,
    "active": true
  },
  "MNT": {
    "name": "Tugrik",
    "digits": 2,
    "active": true
  },
  "MOP": {
    "name": "Pataca",
    "digits": 2,
    "active": true
  },
  "MRO": {
    "name": "Ouguiya",
    "digits": null,
    "active": false
  },
  "MRU": {
    "name": "Ouguiya",
    "digits": 2,
    "active": true
  },
  "MTL": {
    "name": "Maltese Lira",
    "digits": null,
    "active": false
  },
  "MTP": {
    "name": "Maltese Pound",
    "digits": null,
    "active": false
  },
  "MUR": {
    "name": "Mauritius Rupee",
    "digits": 2,
    "active": true
  },
  "MVQ": {
    "name": "Maldive Rupee",
    "digits": null,
    "active": false
  },
  "MVR": {
    "name": "Rufiyaa",
    "digits": 2,
    "active": true
  },
  "MWK": {
    "name": "Malawi Kwacha",
    "digits": 2,
    "active": true
  },
  "MXN": {
    "name": "Mexican Peso",
    "digits": 2,
    "active": true
  },
  "MXP": {
    "name": "Mexican Peso",
    "digits": null,
    "active": false
  },
  "MXV": {
    "name": "Mexican Unidad de Inversion (UDI)",
    "digits": 2,
    "active": true
  },
  "MYR": {
    "name": "Malaysian Ringgit",
    "digits": 2,
    "active": true
  },
  "MZE": {
    "name": "Mozambique Escudo",
    "digits": null,
    "active": false
  },
  "MZM": {
    "name": "Mozambique Metical",
    "digits": null,
    "active": false
  },
  "MZN": {
    "name": "Mozambique Metical",
    "digits": 2,
    "active": true
  },
  "NAD": {
    "name": "Namibia Dollar",
    "digits": 2,
    "active": true
  },
  "NGN": {
    "name": "Naira",
    "digits": 2,
    "active": true
  },
  "NIC": {
    "name": "Cordoba",
    "digits": null,
    "active": false
  },
  "NIO": {
    "name": "Cordoba Oro",
    "digits": 2,
    "active": true
  },
  "NLG": {
    "name": "Netherlands Guilder",
    "digits": null,
    "active": false
  },
  "NOK": {
    "name": "Norwegian Krone",
    "digits": 2,
    "active": true
  },
  "NPR": {
    "name": "Nepalese Rupee",
    "digits": 2,
    "active": true
  },
  "NZD": {
    "name": "New Zealand Dollar",
    "digits": 2,
    "active": true
  },
  "OMR": {
    "name": "Rial Omani",
    "digits": 3,
    "active": true
  },
  "PAB": {
    "name": "Balboa",
    "digits": 2,
    "active": true
  },
  "PEH": {
    "name": "Sol",
    "digits": null,
    "active": false
  },
  "PEI": {
    "name": "Inti",
    "digits": null,
    "active": false
  },
  "PEN": {
    "name": "Sol",
    "digits": 2,
    "active": true
  },
  "PES": {
    "name": "Sol",
    "digits": null,
    "active": false
  },
  "PGK": {
    "name": "Kina",
    "digits": 2,
    "active": true
  },
  "PHP": {
    "name": "Philippine Peso",
    "digits": 2,
    "active": true
  },
  "PKR": {
    "name": "Pakistan Rupee",
    "digits": 2,
    "active": true
  },
  "PLN": {
    "name": "Zloty",
    "digits": 2,
    "active": true
  },
  "PLZ": {
    "name": "Zloty",
    "digits": null,
    "active": false
  },
  "PTE": {
    "name": "Portuguese Escudo",
    "digits": null,
    "active": false
  },
  "PYG": {
    "name": "Guarani",
    "digits": 0,
    "active": true
  },
  "QAR": {
    "name": "Qatari Rial",
    "digits": 2,
    "active": true
  },
  "RHD": {
    "name": "Rhodesian Dollar",
    "digits": null,
    "active": false
  },
  "ROK": {
    "name": "Leu A/52",
    "digits": null,
    "active": false
  },
  "ROL": {
    "name": "Old Leu",
    "digits": null,
    "active": false
  },
  "RON": {
    "name": "Romanian Leu",
    "digits": 2,
    "active": true
  },
  "RSD": {
    "name": "Serbian Dinar",
    "digits": 2,
    "active": true
  },
  "RUB": {
    "name": "Russian Ruble",
    "digits": 2,
    "active": true
  },
  "RUR": {
    "name": "Russian Ruble",
    "digits": null,
    "active": false
  },
  "RWF": {
    "name": "Rwanda Franc",
    "digits": 0,
    "active": true
  },
  "SAR": {
    "name": "Saudi Riyal",
    "digits": 2,
    "active": true
  },
  "SBD": {
    "name": "Solomon Islands Dollar",
    "digits": 2,
    "active": true
  },
  "SCR": {
    "name": "Seychelles Rupee",
    "digits": 2,
    "active": true
  },
  "SDD": {
    "name": "Sudanese Dinar",
    "digits": null,
    "active": false
  },
  "SDG": {
    "name": "Sudanese Pound",
    "digits": 2,
    "active": true
  },
  "SDP": {
    "name": "Sudanese Pound",
    "digits": null,
    "active": false
  },
  "SEK": {
    "name": "Swedish Krona",
    "digits": 2,
    "active": true
  },
  "SGD": {
    "name": "Singapore Dollar",
    "digits": 2,
    "active": true
  },
  "SHP": {
    "name": "Saint Helena Pound",
    "digits": 2,
    "active": true
  },
  "SIT": {
    "name": "Tolar",
    "digits": null,
    "active": false
  },
  "SKK": {
    "name": "Slovak Koruna",
    "digits": null,
    "active": false
  },
  "SLE": {
    "name": "Leone",
    "digits": 2,
    "active": true
  },
  "SLL": {
    "name": "Leone",
    "digits": null,
    "active": false
  },
  "SOS": {
    "name": "Somali Shilling",
    "digits": 2,
    "active": true
  },
  "SRD": {
    "name": "Surinam Dollar",
    "digits": 2,
    "active": true
  },
  "SRG": {
    "name": "Surinam Guilder",
    "digits": null,
    "active": false
  },
  "SSP": {
    "name": "South Sudanese Pound",
    "digits": 2,
    "active": true
  },
  "STD": {
    "name": "Dobra",
    "digits": null,
    "active": false
  },
  "STN": {
    "name": "Dobra",
    "digits": 2,
    "active": true
  },
  "SUR": {
    "name": "Rouble",
    "digits": null,
    "active": false
  },
  "SVC": {
    "name": "El Salvador Colon",
    "digits": 2,
    "active": true
  },
  "SYP": {
    "name": "Syrian Pound",
    "digits": 2,
    "active": true
  },
  "SZL": {
    "name": "Lilangeni",
    "digits": 2,
    "active": true
  },
  "THB": {
    "name": "Baht",
    "digits": 2,
    "active": true
  },
  "TJR": {
    "name": "Tajik Ruble",
    "digits": null,
    "active": false
  },
  "TJS": {
    "name": "Somoni",
    "digits": 2,
    "active": true
  },
  "TMM": {
    "name": "Turkmenistan Manat",
    "digits": null,
    "active": false
  },
  "TMT": {
    "name": "Turkmenistan New Manat",
    "digits": 2,
    "active": true
  },
  "TND": {
    "name": "Tunisian Dinar",
    "digits": 3,
    "active": true
  },
  "TOP": {
    "name": "Pa’anga",
    "digits": 2,
    "active": true
  },
  "TPE": {
    "name": "Timor Escudo",
    "digits": null,
    "active": false
  },
  "TRL": {
    "name": "Old Turkish Lira",
    "digits": null,
    "active": false
  },
  "TRY": {
    "name": "Turkish Lira",
    "digits": 2,
    "active": true
  },
  "TTD": {
    "name": "Trinidad and Tobago Dollar",
    "digits": 2,
    "active": true
  },
  "TWD": {
    "name": "New Taiwan Dollar",
    "digits": 2,
    "active": true
  },
  "TZS": {
    "name": "Tanzanian Shilling",
    "digits": 2,
    "active": true
  },
  "UAH": {
    "name": "Hryvnia",
    "digits": 2,
    "active": true
  },
  "UAK": {
    "name": "Karbovanet",
    "digits": null,
    "active": false
  },
  "UGS": {
    "name": "Uganda Shilling",
    "digits": null,
    "active": false
  },
  "UGW": {
    "name": "Old Shilling",
    "digits": null,
    "active": false
  },
  "UGX": {
    "name": "Uganda Shilling",
    "digits": 0,
    "active": true
  },
  "USN": {
    "name": "US Dollar (Next day)",
    "digits": 2,
    "active": true
  },
  "USS": {
    "name": "US Dollar (Same day)",
    "digits": null,
    "active": false
  },
  "UYI": {
    "name": "Uruguay Peso en Unidades Indexadas (UI)",
    "digits": 0,
    "active": true
  },
  "UYN": {
    "name": "Old Uruguay Peso",
    "digits": null,
    "active": false
  },
  "UYP": {
    "name": "Uruguayan Peso",
    "digits": null,
    "active": false
  },
  "UYU": {
    "name": "Peso Uruguayo",
    "digits": 2,
    "active": true
  },
  "UYW": {
    "name": "Unidad Previsional",
    "digits": 4,
    "active": true
  },
  "UZS": {
    "name": "Uzbekistan Sum",
    "digits": 2,
    "active": true
  },
  "VEB": {
    "name": "Bolivar",
    "digits": null,
    "active": false
  },
  "VED": {
    "name": "Bolívar Soberano",
    "digits": 2,
    "active": true
  },
  "VEF": {
    "name": "Bolívar",
    "digits": null,
    "active": false
  },
  "VES": {
    "name": "Bolívar Soberano",
    "digits": 2,
    "active": true
  },
  "VNC": {
    "name": "Old Dong",
    "digits": null,
    "active": false
  },
  "VND": {
    "name": "Dong",
    "digits": 0,
    "active": true
  },
  "VUV": {
    "name": "Vatu",
    "digits": 0,
    "active": true
  },
  "WST": {
    "name": "Tala",
    "digits": 2,
    "active": true
  },
  "XAD": {
    "name": "Arab Accounting Dinar",
    "digits": 2,
    "active": true
  },
  "XAF": {
    "name": "CFA Franc BEAC",
    "digits": 0,
    "active": true
  },
  "XAG": {
    "name": "Silver",
    "digits": null,
    "active": true
  },
  "XAU": {
    "name": "Gold",
    "digits": null,
    "active": true
  },
  "XBA": {
    "name": "Bond Markets Unit European Composite Unit (EURCO)",
    "digits": null,
    "active": true
  },
  "XBB": {
    "name": "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
    "digits": null,
    "active": true
  },
  "XBC": {
    "name": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
    "digits": null,
    "active": true
  },
  "XBD": {
    "name": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
    "digits": null,
    "active": true
  },
  "XCD": {
    "name": "East Caribbean Dollar",
    "digits": 2,
    "active": true
  },
  "XCG": {
    "name": "Caribbean Guilder",
    "digits": 2,
    "active": true
  },
  "XDR": {
    "name": "SDR (Special Drawing Right)",
    "digits": null,
    "active": true
  },
  "XEU": {
    "name": "European Currency Unit (E.C.U)",
    "digits": null,
    "active": false
  },
  "XFO": {
    "name": "Gold-Franc",
    "digits": null,
    "active": false
  },
  "XFU": {
    "name": "UIC-Franc",
    "digits": null,
    "active": false
  },
  "XOF": {
    "name": "CFA Franc BCEAO",
    "digits": 0,
    "active": true
  },
  "XPD": {
    "name": "Palladium",
    "digits": null,
    "active": true
  },
  "XPF": {
    "name": "CFP Franc",
    "digits": 0,
    "active": true
  },
  "XPT": {
    "name": "Platinum",
    "digits": null,
    "active": true
  },
  "XRE": {
    "name": "RINET Funds Code",
    "digits": null,
    "active": false
  },
  "XSU": {
    "name": "Sucre",
    "digits": null,
    "active": true
  },
  "XUA": {
    "name": "ADB Unit of Account",
    "digits": null,
    "active": true
  },
  "YDD": {
    "name": "Yemeni Dinar",
    "digits": null,
    "active": false
  },
  "YER": {
    "name": "Yemeni Rial",
    "digits": 2,
    "active": true
  },
  "YUD": {
    "name": "New Yugoslavian Dinar",
    "digits": null,
    "active": false
  },
  "YUM": {
    "name": "New Dinar",
    "digits": null,
    "active": false
  },
  "YUN": {
    "name": "Yugoslavian Dinar",
    "digits": null,
    "active": false
  },
  "ZAL": {
    "name": "Financial Rand",
    "digits": null,
    "active": false
  },
  "ZAR": {
    "name": "Rand",
    "digits": 2,
    "active": true
  },
  "ZMK": {
    "name": "Zambian Kwacha",
    "digits": null,
    "active": false
  },
  "ZMW": {
    "name": "Zambian Kwacha",
    "digits": 2,
    "active": true
  },
  "ZRN": {
    "name": "New Zaire",
    "digits": null,
    "active": false
  },
  "ZRZ": {
    "name": "Zaire",
    "digits": null,
    "active": false
  },
  "ZWC": {
    "name": "Rhodesian Dollar",
    "digits": null,
    "active": false
  },
  "ZWD": {
    "name": "Zimbabwe Dollar",
    "digits": null,
    "active": false
  },
  "ZWG": {
    "name": "Zimbabwe Gold",
    "digits": 2,
    "active": true
  },
  "ZWL": {
    "name": "Zimbabwe Dollar",
    "digits": null,
    "active": false
  },
  "ZWN": {
    "name": "Zimbabwe Dollar (new)",
    "digits": null,
    "active": false
  },
  "ZWR": {
    "name": "Zimbabwe Dollar",
    "digits": null,
    "active": false
  }
} as const;
